import Button from '@mui/material/Button';
import PlanPaymentSuccess from './PlanPaymentSuccess';
import { STRIPE_CUSTOMER_PORTAL_LINK } from '../../../helpers/graphql/stripe';
import { useState } from 'react';
import graphQLClient from '../../../helpers/graphQLClient';
import dayjs from 'dayjs';

export default function PlanCustomerPortal({
  plan,
  paymentSuccess,
  blogId,
  isCancelled,
  expiryDate,
}) {
  const [checkoutClicked, setCheckoutClicked] = useState(false);

  const getCustomerPortalLink = () => {
    setCheckoutClicked(true);
    graphQLClient(STRIPE_CUSTOMER_PORTAL_LINK, {
      blogId,
    })
      .then(res => {
        //   Redirect to checkout link
        if (res && res.stripeCustomerPortalLink) {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          if (isIOS) {
            window.open(res.stripeCustomerPortalLink, '_blank');
          } else {
            window.location.href = res.stripeCustomerPortalLink;
          }
        }
        // else: TODO: Show error snackbar
      })
      .catch(err => {
        console.log(err);
        // TODO: Show error snackbar
      });
  };

  return (
    <>
      {paymentSuccess && <PlanPaymentSuccess />}
      {new Date(expiryDate) > new Date() ? (
        <>
          <p>
            You are subscriped to the {plan} plan.{' '}
            {isCancelled ? (
              <>
                You have cancelled your subscription. It will end on{' '}
                {dayjs(expiryDate).format('DD/MM/YYYY')}.
              </>
            ) : (
              ''
            )}
          </p>
          <p>
            To switch to a different plan or {isCancelled ? 'renew' : 'cancel'}{' '}
            your subscription, click the button below to open the subscription
            portal. You can also manage your billing methods and view invoices.
          </p>
        </>
      ) : (
        <p>
          Oops, looks like your hosting subscription has expired! Don&apos;t
          worry, your posts will still be accessible on TravelFeed, but in order
          to continue hosting your blog and all the amazing content you&apos;ve
          created, you&apos;ll need to renew your subscription. Click the button
          below to open the subscription portal and keep your blog up and
          running!
        </p>
      )}

      <Button
        color="primary"
        variant="contained"
        onClick={getCustomerPortalLink}
        disabled={checkoutClicked}
      >
        Manage your subscription
      </Button>
    </>
  );
}
